import Header from "./Components/Header";
import Meme from "./Components/Meme";

function App() {
  return (
    <div className="App">
      <Header />
      <hr />
      <Meme />
    </div>
  );
}

export default App;
